import { ReactNode } from "react";
import i18n from "i18n";

type componentPropsType = {
  type: string;
  disabled: boolean;
  placeholder: string;
  maxLength?: number;
};

type SchemaFieldType = {
  label: string;
  component: ReactNode;
  componentProps: componentPropsType;
};

export type TagsFormControlsValues = {
  name: string;
};
export type ViolationsFormControlsValues = {
  decisionTypeID: number | null;
  name: string;
  policy: string;
};

export type SeriousOffenseReasonControlsValues = {
  name: string;
  id?: number;
};

export type SuggestionFormControlsValues = {
  text: string;
};

export type UsersCharacteristicFormControlsValues = {
  name: string;
};

export type RejectionReasonFormControlsValues = {
  name: string;
  disable: boolean;
};

export type TabEntitySchemaType = {
  [fieldName: string]: SchemaFieldType;
};

export type Tag = {
  id: number;
  name: string;
  disable: boolean;
  index: number;
};
export type Violation = {
  id: number;
  name: string;
  policy: string;
  decisionTypeID: string;
  disable: boolean;
  forVolunteer: boolean;
  code?: number;
};

export type SeriousOffenseReason = {
  id: number;
  name: string;
  disable: boolean;
  isEditable: boolean;
};

export type Suggestion = {
  id: number;
  title: string;
  text: string;
  disable: boolean;
  isDefaultRejectionMessage: boolean;
};
export type UsersCharacteristic = {
  id: number;
  name: string;
  disable: boolean;
};

export type UpdateFormValidations = {
  headLine: string;
  content: string;
};
export type UpdateFormValues = {
  id?: number;
  createdOn?: Date;
  updateOn?: Date;
  showInApp?: boolean;
  headLine: string;
  content: string;
  url?: string;
  isPushNotification?: boolean;
  isPositiveUpdate?: boolean;
  isActive?: boolean;
  expirationDate?: Date;
  fileName?: string;
  file?: Blob;
};

export const tagsTabFields: TabEntitySchemaType[] = [
  {
    name: {
      label: i18n.t("שם תגית"),
      component: "input",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס שם תגית"),
        maxLength: 28,
      },
    },
  },
];
export const violationTabFields: TabEntitySchemaType[] = [
  {
    name: {
      label: i18n.t("שם העבירה"),
      component: "input",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס שם עבירה"),
        maxLength: 240,
      },
    },
  },
  {
    policy: {
      label: i18n.t("policy"),
      component: "input",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס מדיניות"),
        maxLength: 240,
      },
    },
  },
  {
    decisionTypeID: {
      label: i18n.t("decision"),
      component: "select",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס טקסט החלטה"),
      },
    },
  },
];
export const SeriousOffenseReasonTabFields: TabEntitySchemaType[] = [
  {
    name: {
      label: i18n.t("שם סיבת עבירה חמורה"),
      component: "input",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס שם סיבת עבירה חמורה"),
        maxLength: 240,
      },
    },
  },
];

export const suggestionTabFields: TabEntitySchemaType[] = [
  {
    title: {
      label: i18n.t("כותרת"),
      component: "input",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס כותרת"),
        maxLength: 50,
      },
    },
  },
  {
    text: {
      label: i18n.t("הצעה"),
      component: "textarea",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס הצעה"),
        maxLength: 1000,
      },
    },
  },
];

export const usersCharacteristicsTabFields: TabEntitySchemaType[] = [
  {
    name: {
      label: i18n.t("שם מאפיין"),
      component: "textarea",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס מאפיין"),
        maxLength: 1001,
      },
    },
  },
];

export const rejectionReasonsTabFields: TabEntitySchemaType[] = [
  {
    name: {
      label: i18n.t("שם סיבת פסילה"),
      component: "input",
      componentProps: {
        type: "text",
        disabled: false,
        placeholder: i18n.t("הכנס שם סיבת פסילה"),
        maxLength: 240,
      },
    },
  },
];

export type Decision = {
  name: string;
  code?: number;
};
